export default "__VITE_ASSET__CysOS7ND__"